import {Auth} from "../mixins/AuthMixin"

export default {
  onlyGuest(args, to, from, next) {
    if (Auth.isAuthenticated())
      next({name: 'index'})
    else
      next()
  },
  onlyAuth(args, to, from, next) {
    if (Auth.isAuthenticated())
      next()
    else
      next('/login?redirect=' + to.path)
  },
}
